import { render, staticRenderFns } from "./CmgMealNonBuilder.vue?vue&type=template&id=4ec12cae&scoped=true&lang=pug&"
import script from "./cmg-meal-non-builder.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-non-builder.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealNonBuilder.vue?vue&type=style&index=0&id=4ec12cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec12cae",
  null
  
)

export default component.exports